import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/buttons/buttons.js';
import { joinClasses } from 'utils/utils';
import Button from 'components/bolt/button/button';
import { trackCarouselEngagement } from 'utils/track.js';
import s from 'components/bolt/hub/components/buttons/buttons.sss';

export default class Buttons extends BaseComp.default {

	onLinkClick(btn) {
		if (btn?.btnCopy === 'Watch Now') {
			trackCarouselEngagement(btn);
		}
		return super.onLinkClick(btn);
	}

	async triggerAction(path, label, sameWindow, videoOverlay, textOverlay, btnIndex) {
		const { isHero, carouselTitle, filmTitle } = this.props;

		if (isHero) {
			Store.emit('POWSTER_GA_EVENT_TRACK', `hero-engagement`, 'hero', label);
		} else {
			Store.emit('POWSTER_GA_EVENT_TRACK', 'most-popular-collections', 'collection', carouselTitle);
			Store.emit('POWSTER_GA_EVENT_TRACK', `most-popular-titles`, 'title', filmTitle);
			Store.emit('POWSTER_GA_EVENT_TRACK', 'carousel-button-click', 'carousel-engagement', label);
		}

		if (textOverlay) {
			this.toggleTextOverlay(true, `button-${btnIndex}`);
			return;
		}

		if (path === 'scrollTop') {
			smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		} else if (videoOverlay) {
			Store.emit('ENABLE_TRAILER_OVERLAY', videoOverlay);
		} else {
			const mainScroll = document.getElementById('mainScroll');
			const logo = label.toLowerCase() === 'logo';
			const activePage = Store.get().activePage;
			const isRootPath = activePage?.path === '/';
			if (isRootPath && logo) {
				return smoothScrollTo(mainScroll, 0, 300);
			}

			await animation(mainScroll, 'left', 400);
			navigateInternally(path);
		}
	}
	
	renderBtn(btn, index) {
		let content = [
			<span class={joinClasses(s.btnCopy, 'largeB')}>{btn.btnCopy}</span>,
			btn.icon && <img class={s.icon} src={btn.icon} alt="" />
		];
		if (/^(https?|mailto):/.test(btn.link)) {
			return (
				<a
					class={s.btn}
					href={btn.link}
					target={btn.sameWindow ? '_self' : '_blank'}
					ariaLabel={btn.btnCopy}
					onClick={() => this.onLinkClick(btn)}
				>
					{content}
				</a>
			);
		}

		return (
			<Button
				class={joinClasses(s.btn, (!btn.textOverlay?.content && !btn.videoOverlay?.video) && s.buttonDisabled)}
				trigger={() => this.triggerAction(btn.link, btn.btnCopy, btn.sameWindow, btn.videoOverlay?.video, btn.textOverlay?.content, index)}
				ariaLabel={btn.btnCopy}
			>
				{content}
			</Button>
		);
	}

}